import { createTheme } from "@mui/material/styles";

const industryPalettes = {
  finance: { primary: "#1e3a8a", accent: "#3b82f6", bg: "#f8fafc", text: "#0f172a", radius: 8 },
  healthcare: { primary: "#0d9488", accent: "#2dd4bf", bg: "#ffffff", text: "#134e4a", radius: 24 },
  insurance: { primary: "#a65215", accent: "#e9a026", bg: "#faf5f0", text: "#3d200f", radius: 16 },
  government: { primary: "#1e3a8a", accent: "#3b82f6", bg: "#f8fafc", text: "#0f172a", radius: 12 },
  corporate: { primary: "#4338ca", accent: "#6366f1", bg: "#020617", text: "#f8fafc", radius: 12 },
};

export function createPortalTheme(industry) {
  const t = industryPalettes[industry] || industryPalettes.finance;
  return createTheme({
    palette: {
      mode: industry === "corporate" ? "dark" : "light",
      primary: { main: t.primary, contrastText: "#fff" },
      secondary: { main: t.accent },
      background: { default: t.bg, paper: industry === "corporate" ? "#0f172a" : "#ffffff" },
      text: { primary: t.text, secondary: industry === "corporate" ? "#94a3b8" : "#64748b" },
    },
    typography: {
      fontFamily: industry === "healthcare"
        ? '"Outfit", "Plus Jakarta Sans", sans-serif'
        : '"Inter", "Plus Jakarta Sans", sans-serif',
      button: { fontWeight: 800, textTransform: "none" },
    },
    shape: { borderRadius: t.radius },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: t.radius, fontWeight: 800 },
        },
      },
      MuiPaper: {
        styleOverrides: {
          rounded: { borderRadius: t.radius },
        },
      },
    },
  });
}

export default createPortalTheme;
